export const CLIENT_CLOSED_EVENT = "muycoach:client-closed";

// La API responde 409 CLIENT_CLOSED cuando el coach intenta actuar sobre un cliente congelado.
// Routes.js muestra el mensaje; la pantalla sigue recibiendo el error de siempre.
export const handleClientClosed = (error) => {
    if (error?.response?.status === 409 && error.response.data?.code === "CLIENT_CLOSED") {
        window.dispatchEvent(new CustomEvent(CLIENT_CLOSED_EVENT));
    }
    return Promise.reject(error);
};
